"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container flex-col" };
const _hoisted_2 = { class: "card-container" };
const CustomButton_vue_1 = __importDefault(require("../../../components/backend/CustomButton.vue"));
const LocationElement_vue_1 = __importDefault(require("./LocationElement.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Locations',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                    to: "/admin/locations/edit",
                    "btn-type": "primary",
                    class: "w-98"
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)("Új telephely ")
                    ]),
                    _: 1
                }),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(3, (n, index) => {
                        return (0, vue_2.createVNode)(LocationElement_vue_1.default, { key: index });
                    }), 64))
                ])
            ]));
        };
    }
});
